import { shortenName } from '../../../utils/name';

const KIDDIE_GRADES = ['PK', 'KG', '01', '02', '03'];
const MIDDLE_GRADES = ['04', '05', '06', '07', '08'];

export function isKiddieUser(grade) {
  return KIDDIE_GRADES.indexOf(grade) >= 0;
}

export function isMiddleUser(grade) {
  return MIDDLE_GRADES.indexOf(grade) >= 0;
}

export function isJrUser(grade) {
  return isKiddieUser(grade) || isMiddleUser(grade);
}

export function getShortName(student) {
  if (student.firstName) {
    return shortenName(student.firstName, student.lastName);
  }
  return shortenName(student.first_name, student.last_name);
}
